import React, { useEffect } from 'react';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import { useFormikContext } from 'formik';

import useComparable from '../hooks/useComparable';

const FieldIterables = ({
  name,
  children,
  tail,
  helpers,
}) => {
  const ctx = useFormikContext();
  const arr = get(ctx.values, name, []);

  useEffect(() => {
    if (tail !== undefined && helpers) {
      if (!isEqual(arr.slice(-1)[0], tail)) {
        // if last row isn't empty, push
        helpers.push(tail);
      } else if (arr.length > 1 && isEqual(arr.slice(-2)[0], tail)) {
        // if last 2 rows are empty, pop
        helpers.pop();
      }
    }
  }, [typeof tail, useComparable(arr)]);

  return (
    <>
      {arr.map((v, i) => children(v, i, helpers))}
    </>
  );
};

export default FieldIterables;
